import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import { defaultA5ChromeProps } from "@/components/common-receipt/a5-print-defaults";
import {
  resolveBookingDisplayMohalla,
  type BookingMohallaSource,
} from "@/containers/bookings/resolve-booking-display-mohalla";

const toWords = new ToWords();

export type DepositReceiptPrintRecord = {
  id?: string | number;
  receiptNo?: string;
  date?: string;
  organiser?: string;
  organiserIts?: string;
  amount?: number;
  createdBy?: string;
  booking?: BookingMohallaSource & {
    bookingNo?: string;
    purpose?: string;
    purposeName?: string;
  };
};

export function depositReceiptPurposeLine(
  booking?: (BookingMohallaSource & { purpose?: string; purposeName?: string }) | null
): string {
  const purpose = (booking?.purposeName || booking?.purpose || "").trim();
  const mohalla = resolveBookingDisplayMohalla(booking);
  const parts: string[] = [];
  if (purpose) {
    parts.push(purpose);
  }
  if (mohalla) {
    parts.push(`Mohalla ${mohalla}`);
  }
  return parts.length > 0 ? parts.join(" / ") : "-";
}

export function depositReceiptLines(data: DepositReceiptPrintRecord): ReceiptLineItem[] {
  const booking = data.booking;
  return [
    {
      left: "Received from",
      right: String(data.organiser || ""),
      bold: true,
    },
    {
      left: "ITS No.",
      right: `${data.organiserIts || "-"} / Reference No. ${booking?.bookingNo || "-"}`,
    },
    {
      left: "Purpose",
      right: depositReceiptPurposeLine(booking),
    },
    {
      left: "Contribution Amount Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
  ];
}

export function depositReceiptA5Props(data: DepositReceiptPrintRecord) {
  return {
    ...defaultA5ChromeProps(),
    subTitle: "Contribution Receipt",
    receiptNo: data.receiptNo,
    date: data.date,
    receiptLines: depositReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${data.id}|${data.createdBy}`,
    footerNote: "This receipt is computer generated and does not require a physical signature.",
  };
}
